// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"styles_brandLogo__1LLep","responsiveBrandLogo":"styles_responsiveBrandLogo__LrrXr"};